// 优惠价模式
const DISCOUNT_PRICE_MODE_NO = 1 // 无优惠价
const DISCOUNT_PRICE_MODE_UNIFIED_MEMBER_PRICE = 2 // 统一会员价
const DISCOUNT_PRICE_MODE_DISCOUNT_PRICE = 3 // 折扣价

const map = new Map([
  [DISCOUNT_PRICE_MODE_NO, { mean: '无优惠价', type: 'success' }],
  [DISCOUNT_PRICE_MODE_UNIFIED_MEMBER_PRICE, { mean: '统一会员价', type: 'primary' }],
  [DISCOUNT_PRICE_MODE_DISCOUNT_PRICE, { mean: '会员折扣价', type: 'danger' }]
])

export default {
  map,
  DISCOUNT_PRICE_MODE_NO,
  DISCOUNT_PRICE_MODE_UNIFIED_MEMBER_PRICE,
  DISCOUNT_PRICE_MODE_DISCOUNT_PRICE
}
